export default {
  NOT_HANDLED: 0,
  IGNORED: 1,
  HANDLED: 2,
  HANDLED_AUTO: 3,
}
